import React from 'react'
import { navigate, useStaticQuery, graphql } from 'gatsby'
import { getImage } from 'gatsby-plugin-image'
import { BgImage } from 'gbimage-bridge'

import * as styles from './Search.module.css'

function Search() {
  const data = useStaticQuery(graphql`
    query SearchComponentQuery {
      file(relativePath: { eq: "banner/knowledgebase-banner.jpg" }) {
        childImageSharp {
          gatsbyImageData(quality: 90, layout: FULL_WIDTH)
        }
      }
    }
  `)

  const handleSearch = (event) => {
    event.preventDefault()
    const query = event.target.elements.q.value
    if (query) navigate(`/search?q=${query}`)
  }

  return (
    <div className="et_pb_section et_pb_fullwidth_section">
      <div className="et_pb_slider et_pb_slider_no_arrows et_pb_slider_no_pagination">
        <div className="et_pb_slides">
          <BgImage
            className="et_pb_slide et_pb_bg_layout_dark et_pb_media_alignment_center"
            image={getImage(data.file)}
          >
            <div className="et_pb_container clearfix">
              <div className="et_pb_slide_description">
                <h2>Have a Question?</h2>
                <div className="et_pb_slide_content">
                  <p className={styles.description}>
                    Search our knowledge base below to easily find the answers!
                  </p>
                  <form
                    role="search"
                    method="get"
                    className={styles.searchform}
                    action="/search"
                    onSubmit={handleSearch}
                  >
                    <input
                      type="text"
                      name="q"
                      placeholder="Enter your question here"
                    />
                    <button type="submit">Search</button>
                  </form>
                </div>
              </div>
            </div>
          </BgImage>
        </div>
      </div>
    </div>
  )
}

export default Search
